module.exports = __webpack_public_path__ + "media/images/pc/articles/report_temp_02-6a87ee3be515167d4b4ab70a0711e284.webp";